import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CreditCardIcon, TruckIcon, CheckCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
interface CheckoutModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function CheckoutModal({
  isOpen,
  onClose
}: CheckoutModalProps) {
  const {
    cartTotal,
    clearCart
  } = useCart();
  const [step, setStep] = useState(1);
  const [isProcessing, setIsProcessing] = useState(false);
  const handleNext = (e: React.FormEvent) => {
    e.preventDefault();
    if (step === 2) {
      setIsProcessing(true);
      setTimeout(() => {
        setIsProcessing(false);
        setStep(3);
      }, 2000);
    } else {
      setStep(step + 1);
    }
  };
  const handleFinish = () => {
    clearCart();
    onClose();
    setStep(1);
  };
  return <AnimatePresence data-id="element-50" data-mp="3l8769gxvghe4">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100]" data-id="element-51" data-mp="3q3mjc6o2299h" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="fixed inset-0 m-auto w-full max-w-2xl h-fit max-h-[90vh] bg-white rounded-3xl shadow-2xl z-[101] overflow-hidden flex flex-col" data-id="element-52" data-mp="1g7ikgdnaqavv">
            <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50/50" data-id="element-53" data-mp="ngqtpvp02efx">
              <div className="flex items-center gap-3" data-id="element-54" data-mp="ihxe9xq5kdd4">
                <div className="w-10 h-10 bg-clinical-blue/10 rounded-xl flex items-center justify-center text-clinical-blue" data-id="element-55" data-mp="ii5pll6mnam7">
                  <CreditCardIcon className="w-5 h-5" data-id="element-56" data-mp="8we89vxdxrhb" />
                </div>
                <div data-id="element-57" data-mp="dufugpq3y6x0">
                  <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight" data-id="element-58" data-mp="3v19jznt6pzkg">
                    Secure Checkout
                  </h2>
                  <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-59" data-mp="3vqbetmh6gf6">
                    Step {step} of 3
                  </p>
                </div>
              </div>
              <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full transition-colors" data-id="element-60" data-mp="wib0toje4ig3">
                <XIcon className="w-5 h-5 text-slate-400" data-id="element-61" data-mp="mtt3xie8evhq" />
              </button>
            </div>

            <div className="p-8 overflow-y-auto" data-id="element-62" data-mp="1ajdm3z2k9opy">
              {step === 1 && <form onSubmit={handleNext} className="space-y-6" data-id="element-63" data-mp="1ahkh0o7ljck2">
                  <div className="flex items-center gap-3 mb-4" data-id="element-64" data-mp="1fbopjbwifsn9">
                    <TruckIcon className="w-6 h-6 text-clinical-blue" data-id="element-65" data-mp="2zzzk6gt7kfgq" />
                    <h3 className="text-lg font-bold text-slate-900 uppercase tracking-tight" data-id="element-66" data-mp="2v1fuq6feoljm">
                      Shipping Address
                    </h3>
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-id="element-67" data-mp="39sexh0tk8fva">
                    <input required placeholder="First Name" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 outline-none" data-id="element-68" data-mp="34sahrd0h7p64" />
                    <input required placeholder="Last Name" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 outline-none" data-id="element-69" data-mp="2q2uuw842g3vp" />
                  </div>
                  <input required placeholder="Street Address" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 outline-none" data-id="element-70" data-mp="1b24l6gp1dhq" />
                  <div className="grid grid-cols-3 gap-4" data-id="element-71" data-mp="15ldh8l2icdgw">
                    <input required placeholder="City" className="col-span-1 w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 outline-none" data-id="element-72" data-mp="15jso8zvud2l5" />
                    <input required placeholder="State" className="col-span-1 w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 outline-none" data-id="element-73" data-mp="1jk3i8bsg6xaj" />
                    <input required placeholder="ZIP" className="col-span-1 w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 outline-none" data-id="element-74" data-mp="1yau8hfee5obj" />
                  </div>
                  <button type="submit" className="w-full bg-clinical-blue text-white font-black py-4 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs" data-id="element-75" data-mp="3ir220p2nbn91">
                    Continue to Payment
                  </button>
                </form>}

              {step === 2 && <form onSubmit={handleNext} className="space-y-6" data-id="element-76" data-mp="5cnjq6dezk1f">
                  <div className="flex items-center gap-3 mb-4" data-id="element-77" data-mp="5fjhnup9i8pv">
                    <CreditCardIcon className="w-6 h-6 text-clinical-blue" data-id="element-78" data-mp="l5sia170xtn" />
                    <h3 className="text-lg font-bold text-slate-900 uppercase tracking-tight" data-id="element-79" data-mp="3rtjn306ke9ug">
                      Payment Method
                    </h3>
                  </div>
                  <div className="bg-slate-50 p-6 rounded-2xl border border-slate-200 space-y-4" data-id="element-80" data-mp="ocb8qqb1ps4h">
                    <div className="flex items-center justify-between border-b border-slate-200 pb-4" data-id="element-81" data-mp="2ik5dvxfjvs59">
                      <span className="text-sm font-bold text-slate-900 uppercase tracking-widest" data-id="element-82" data-mp="2njhwu73awf2k">
                        Total to Pay
                      </span>
                      <span className="text-xl font-black text-clinical-blue" data-id="element-83" data-mp="28rzi0cm6gqks">
                        ${cartTotal.toFixed(2)}
                      </span>
                    </div>
                    <div className="space-y-4" data-id="element-84" data-mp="1zs44i155gjhl">
                      <input required placeholder="Card Number" className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 outline-none" data-id="element-85" data-mp="23vilau0wx3w3" />
                      <div className="grid grid-cols-2 gap-4" data-id="element-86" data-mp="3k990avtklcki">
                        <input required placeholder="MM/YY" className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 outline-none" data-id="element-87" data-mp="3ka20fdy0x3to" />
                        <input required placeholder="CVC" className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 outline-none" data-id="element-88" data-mp="18ngq3x5i0dq5" />
                      </div>
                    </div>
                  </div>
                  <button disabled={isProcessing} type="submit" className="w-full bg-clinical-blue text-white font-black py-4 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs flex items-center justify-center gap-3" data-id="element-89" data-mp="1rd6heaa1yhdb">
                    {isProcessing ? <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-90" data-mp="bxheftu1wz3c"></span> : <>Pay ${cartTotal.toFixed(2)}</>}
                  </button>
                  <div className="flex items-center justify-center gap-2 text-[10px] text-slate-400 font-bold uppercase tracking-widest" data-id="element-91" data-mp="3m6tlu10c7csl">
                    <ShieldCheckIcon className="w-3 h-3" data-id="element-92" data-mp="3r0oa7hqw0fy0" />
                    Secure SSL Encrypted Payment
                  </div>
                </form>}

              {step === 3 && <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-center py-8" data-id="element-93" data-mp="2yc0j35jgiwcj">
                  <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-94" data-mp="nhv2hlksilbr">
                    <CheckCircleIcon className="w-10 h-10" data-id="element-95" data-mp="riop8bmhxu32" />
                  </div>
                  <h3 className="text-3xl font-black text-slate-900 mb-4 uppercase tracking-tight" data-id="element-96" data-mp="2c20ju9sx68n0">
                    Order Confirmed!
                  </h3>
                  <p className="text-slate-500 mb-8 leading-relaxed" data-id="element-97" data-mp="282066rdna1h0">
                    Thank you for your purchase. Your wellness essentials are
                    being prepared for shipment and will arrive in 2-3 business
                    days.
                  </p>
                  <button onClick={handleFinish} className="bg-clinical-blue text-white font-black py-4 px-12 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs shadow-lg shadow-clinical-blue/20" data-id="element-98" data-mp="1tbspag3acqif">
                    Close & Clear Cart
                  </button>
                </motion.div>}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}